import { GlEmptyState, GlModal, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'WorkItemTicketModal',
    components: {
        GlEmptyState,
        GlModal,
        GlSprintf
    },
    emits: [
        'hide'
    ]
};
